<template>
  <div class="item-box-content">
    <el-table
      style="margin-top:20px"
      ref="custromTableRef"
      :data="list"
      max-height="398"
      tooltip-effect="dark"
      :header-cell-style="tableHeader"
      v-loading="loadingTable"
      element-loading-text="拼命加载中请稍后..."
      element-loading-spinner="el-icon-loading"
      border
    >
      <el-table-column prop="brandName" label="品牌"></el-table-column>
      <el-table-column prop="seriesName" label="系列"></el-table-column>
      <el-table-column prop="proName" label="产品名称"></el-table-column>
      <el-table-column prop="proModel" label="型号">
        <template scope="scope">
                  <span
                    class="approval"
                    @click="productSkip(scope.row.proId)"
                  >{{scope.row.proModel}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="proOrderNum" label="订货号"></el-table-column>
      <el-table-column prop="proUnit" label="单位"></el-table-column>
      <el-table-column prop="pccCount" label="数量"></el-table-column>
      <el-table-column prop="proExtype" label="类型"></el-table-column>
      <el-table-column prop="pcbExtimeValue" label="货期">
        <template v-slot="{row}">
          <div>{{row.pcbExtimeValue ||''}}天</div>
        </template>
      </el-table-column>
      <el-table-column prop="purchasePrice" label="采购单价">
        <template v-slot="{row}">
          <div>{{row.purchasePrice | toFixed}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="discountPrice" label="抵扣金额">
        <template v-slot="{row}">
          <div>{{row.discountPrice | toFixed}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="amountPaid" label="实付单价">
        <template v-slot="{row}">
          <div>{{row.amountPaid | toFixed}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="proPrice" label="面价">
        <template v-slot="{row}">
          <div>{{row.proPrice | toFixed}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="deliverState" label="发货状态">

      </el-table-column>
      <el-table-column prop="invoiceState" label="收票状态">

      </el-table-column>
    </el-table>
    <div class="pagination" style="margin-top: 20px;">
      <pagination
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
    </div>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { queryPurchaseRetreatContent } from '@/api/purchase/purchasePlanList'
import { isSuccess } from '@/util/tool'
export default {
  components: {
    pagination: pagination
  },
  data () {
    return {
      list: [],
      loadingTable: false,
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0 // 列表总数
    }
  },
  methods: {
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    productSkip (id) {
      this.$router.push({
        name: 'productDetails',
        query: { id: id }
      })
    },
    getList () {
      const {
        currentPage,
        pageSize
      } = this
      const {
        pcbId
      } = this.$route.query
      queryPurchaseRetreatContent(currentPage, pageSize, pcbId).then(res => {
        if (isSuccess(res)) {
          this.list = res.data.obj.purchaseContractContentVoPage?.records ?? []
          this.total = res.data.obj.purchaseContractContentVoPage?.total ?? 0
        }
      })
    }
  }
}
</script>
